import {ColumnEntity} from '~/types/ColumnEntity';
import {Copy} from './Copy.client';
import {Table} from './Table.client';
import {SANITY_CONTENT_TYPES} from '~/lib/const';
import {ContactFormEmbed} from '~/components/sections/ContactFormEmbed.client';

export function Column({column}: {column: ColumnEntity}) {
  return (
    <div className="flex flex-col lg:flex-row gap-6 my-10">
      {column.content &&
        column.content.map((content, index) => {
          if (!content || !content._type) {
            console.error(
              // @ts-ignore
              `Unknown component. type: ${content?._type} id: ${content?._id}`,
            );
            return null;
          }

          return (
            <div
              key={content.name}
              className="full-width-mobile"
              style={{
                width: `${column?.columnsWidth?.[index] ?? '50'}%`,
              }}
            >
              {content._type === SANITY_CONTENT_TYPES.COPY &&
                content?.copy != null && <Copy copy={content.copy} />}
              {content._type === SANITY_CONTENT_TYPES.TABLE &&
                content.table && (
                  <div>
                    <div className="overflow-auto">
                      <Table table={content} />
                    </div>
                    {content.hideScrollText !== true && (
                      <div className="md:hidden text-16/26 text-gray-500 mt-1">
                        Scroll horizontally to see more.
                      </div>
                    )}
                  </div>
                )}
              {content._type === SANITY_CONTENT_TYPES.CONTACT_FORM && (
                <ContactFormEmbed />
              )}
            </div>
          );
        })}
    </div>
  );
}
